<template lang="pug">
    svg.svg-icon(:class="theClass")
        use(:xlink:href="iconHref" :class="useClass")
</template>

<script>
export default {
    name: 'svg-icon',
    props: {
        iconId: {
            type: String,
            required: true,
        },
        useClass: {
            type: String,
        }
    },
    computed: {
        iconHref() {
            return `#${this.iconId}`
        },
        theClass() {
            return `svg-icon__${this.iconId}`
        },
    },
}
</script>
